<template>
  <v-container
    id="bottom-controls-container"
    class="d-flex flex-column align-center"
  >
    <SelectedPointLayersInfoTable
      v-if="
        visibleButtons.length > 0 &&
          activeButton == 'SelectedPointLayersInfoTable'
      "
      :visible-point-layers="visiblePointLayers"
      :point-layer-types="pointLayerTypes"
    />
    <Screenshot
      v-if="visibleButtons.length > 0 && activeButton == 'Screenshot'"
      v-show="!hideControls"
      @hideBottomControls="hideControls = true"
      @showBottomControls="hideControls = false"
    />
    <v-card
      v-if="visibleButtons.length > 0"
      flat
      :width="navBarWidth"
      color="rgb(255, 0, 0, 0)"
      class="d-flex justify-center"
    >
      <v-bottom-navigation
        v-show="!hideControls"
        class="rounded-pill"
        @change="buttonToggle"
      >
        <v-btn
          v-if="visibleButtons.includes('SelectedPointLayersInfoTable')"
          id="punkte-btn"
          :value="
            visibleButtons.includes('SelectedPointLayersInfoTable')
              ? 'SelectedPointLayersInfoTable'
              : false
          "
          style="height: 100%; width: 100%"
          class="rounded-pill"
        >
          <span>Punkte</span>
          <v-icon>fa-table</v-icon>
        </v-btn>
        <v-btn
          id="screenshot-btn"
          :value="visibleButtons.includes('Screenshot') ? 'Screenshot' : false"
          style="height: 100%; width: 120%"
          class="rounded-pill"
        >
          <span>Screenshot</span>
          <v-icon>fa-image</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-card>
  </v-container>
</template>

<script>
import SelectedPointLayersInfoTable from "@/components/bottomControls/controls/SelectedPointLayersInfoTable";
import Screenshot from "@/components/bottomControls/controls/Screenshot";

export default {
  name: "BottomControls",
  components: { SelectedPointLayersInfoTable, Screenshot },
  props: { pointLayerTypes: Array },
  data() {
    return {
      activeButton: undefined,
      visibleButtons: [],
      visiblePointLayers: [],
      hideControls: false
    };
  },
  computed: {
    navBarWidth() {
      return `${100 + this.visibleButtons.length * 50}px`;
    }
  },
  watch: {
    // deselect previous selected button if no button is visible
    visibleButtons(newVal) {
      if (newVal.length == 0) {
        this.activeButton = undefined;
      }
    }
  },
  mounted() {
    window.EventBus.$on("showBottomControlButton", buttonValue =>
      this.showButton(buttonValue)
    );
    window.EventBus.$on("hideBottomControlButton", buttonValue =>
      this.hideButton(buttonValue)
    );
    window.EventBus.$on(
      "hidePointLayers",
      () => (this.visiblePointLayers = [])
    );
    window.EventBus.$on("showPointLayerInTable", layer =>
      this.visiblePointLayers.push(layer)
    );
  },
  methods: {
    buttonToggle(activeButton) {
      this.activeButton = activeButton;
    },
    showButton(buttonValue) {
      if (!this.visibleButtons.includes(buttonValue)) {
        this.visibleButtons.push(buttonValue);
      }
    },
    hideButton(buttonValue) {
      var i = this.visibleButtons.indexOf(buttonValue);
      if (i !== -1) {
        this.visibleButtons.splice(i, 1);
      }
    }
  }
};
</script>
<style>
#bottom-controls-container {
  position: absolute;
  bottom: 0%;
  max-width: max-content;
}
</style>
